/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/camelcase */
/** ============================ */
/*  This file was autogenerated  */
/*  with `npm run codegen`       */
/* ============================= */

import { gql } from "@apollo/client";
import * as ApolloReactCommon from "@apollo/client";
import * as ApolloReactHooks from "@apollo/client";

import * as Types from "../../../api/types.generated";
export type SplitHardwareRequestByAvailabilityMutationVariables = Types.Exact<{
  original_request_id: Types.Scalars["Float"];
}>;

export type SplitHardwareRequestByAvailabilityMutation = {
  splitHardwareRequestByAvailability: Pick<
    Types.HardwareRequest,
    "id" | "status"
  > & {
    user: Pick<Types.User, "id" | "name" | "email">;
    hardware_item_requests: Array<
      Pick<Types.HardwareItemRequest, "id" | "quantity"> & {
        HardwareItem: Pick<
          Types.HardwareItem,
          "id" | "sku_code" | "total_quantity" | "available_quantity"
        >;
      }
    >;
  };
};

export const SplitHardwareRequestByAvailabilityDocument = gql`
  mutation SplitHardwareRequestByAvailability($original_request_id: Float!) {
    splitHardwareRequestByAvailability(
      original_request_id: $original_request_id
    ) {
      id
      status
      user {
        id
        name
        email
      }
      hardware_item_requests {
        id
        quantity
        HardwareItem {
          id
          sku_code
          total_quantity
          available_quantity
        }
      }
    }
  }
`;

/**
 * __useSplitHardwareRequestByAvailabilityMutation__
 *
 * To run a mutation, you first call `useSplitHardwareRequestByAvailabilityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSplitHardwareRequestByAvailabilityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [splitHardwareRequestByAvailabilityMutation, { data, loading, error }] = useSplitHardwareRequestByAvailabilityMutation({
 *   variables: {
 *      original_request_id: // value for 'original_request_id'
 *   },
 * });
 */
export function useSplitHardwareRequestByAvailabilityMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    SplitHardwareRequestByAvailabilityMutation,
    SplitHardwareRequestByAvailabilityMutationVariables
  >
) {
  return ApolloReactHooks.useMutation<
    SplitHardwareRequestByAvailabilityMutation,
    SplitHardwareRequestByAvailabilityMutationVariables
  >(SplitHardwareRequestByAvailabilityDocument, baseOptions);
}
export type SplitHardwareRequestByAvailabilityMutationHookResult = ReturnType<
  typeof useSplitHardwareRequestByAvailabilityMutation
>;
export type SplitHardwareRequestByAvailabilityMutationResult =
  ApolloReactCommon.MutationResult<SplitHardwareRequestByAvailabilityMutation>;
export type SplitHardwareRequestByAvailabilityMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    SplitHardwareRequestByAvailabilityMutation,
    SplitHardwareRequestByAvailabilityMutationVariables
  >;
